import { announcementRoutes } from '../features/announcement/announcement.routes';
import { consumerRoutes } from '../features/consumer/consumer.routes';
import { invoicesRoutes } from '../features/invoices/invoices.routes';
import { messageRoutes } from '../features/message/message.routes';
import { tariffsRoutes } from '../features/tariff/tariff.routes';
import { toolsRoutes } from '../features/tools/tools.routes';
import { userRoutes } from '../features/user/user.routes';
import { integrationsRoutes } from '../features/integrations/integrations.routes';
import { referralRewardsRoutes } from '../features/referralRewards/referralRewards.routes';

export default {
  pages: {
    mainPage: () => '/',
    signUp: () => '/signup',
    signIn: () => '/signin',
    settings: () => '/settings',
    applicationSettingsPage: () => '/application/settings',
    applicationSettingsPageForAdmin: () => '/application/settings/admin',
    applicationSettingsPageForPortal: () => '/application/settings/portal',
    applicationSettingsPageForMobile: () => '/application/settings/mobile',
    applicationSettingsPageForCommon: () => '/application/settings/common',
    applicationsReferallSettingsPage: () => '/application/settings/referall',
    users: () => '/users',
    forgotPassportPage: () => '/users/:email/restore/:code',
    userLogsPage: () => '/users/:userId/log',
    logByUserIdPage: (id: string) => `/users/${id}/log`,
    consumers: () => '/consumers',
    consumerLogsPage: () => '/consumer/:consumerId/log',
    logByConsumerIdPage: (id: string) => `/consumer/${id}/log`,
    messagesPage: () => '/messages',
    messagePage: () => '/messages/:consumerId',
    messagePageByConsumerId: (id: string) => `/messages/${id}`,
    logsPage: () => 'logs',
    tariffsPage: () => '/tariffs',
    tariffPage: () => '/tariffs/:tariffId',
    updateTariffFeaturePage: () => '/tariffs/:tariffId/:featureId/update',
    updateTariffFeaturePageById: (tariffId: string, featureId: string) =>
      `/tariffs/${tariffId}/${featureId}/update`,
    tariffPageById: (id: string) => `/tariffs/${id}`,
    newTariffPage: () => '/tariffs/new',
    updateTariffPage: () => '/tariffs/:tariffId/update',
    updateTariffPageById: (tariffId: string) => `/tariffs/${tariffId}/update`,
    newTariffFeaturePageById: (tariffId: string) => `/tariffs/${tariffId}/new`,
    newTariffFeaturePage: () => '/tariffs/:tariffId/new',
    invoicments: () => '/invoicments',
    referralRewardsPage: () => '/referral-rewards',
    createAnnouncementPage: () => '/announcements/new',
    updateAnnouncementPage: () => '/announcements/:announcementId/update',
    updateAnnouncementPageById: (announcementId: string) =>
      `/announcements/${announcementId}/update`,
    toolsPage: () => '/tools',
    artifactsPage: () => '/tools/artifacts',
    stylesPage: () => '/tools/styles',
    newStylePage: () => '/tools/styles/new',
    stylePage: () => '/tools/styles/:styleId',
    stylePageById: (styleId: string) => `/tools/styles/${styleId}`,
    updateStylePage: () => '/tools/styles/:styleId/update',
    updateStylePageById: (styleId: string) => `/tools/styles/${styleId}/update`,
    stylePromptPage: () => '/tools/styles/:styleId/prompts/:promptId',
    stylePromptPageById: (styleId: string, promptId: string) =>
      `/tools/styles/${styleId}/prompts/${promptId}`,
    newStylePromptPage: () => '/tools/styles/:styleId/prompts/new',
    newStylePromptPageByStyleId: (styleId: string) => `/tools/styles/${styleId}/prompts/new`,
    // editing a prompt is writing a new version of it, so the prompt it starts from is in the path
    stylePromptVersionPage: () => '/tools/styles/:styleId/prompts/:promptId/new-version',
    stylePromptVersionPageById: (styleId: string, promptId: string) =>
      `/tools/styles/${styleId}/prompts/${promptId}/new-version`,
    modelsPage: () => '/tools/models',
    newModelPage: () => '/tools/models/new',
    modelPage: () => '/tools/models/:modelId',
    modelPageById: (modelId: string) => `/tools/models/${modelId}`,
    updateModelPage: () => '/tools/models/:modelId/update',
    updateModelPageById: (modelId: string) => `/tools/models/${modelId}/update`,
    toolPage: () => '/tools/:toolId',
    toolPageById: (toolId: string) => `/tools/${toolId}`,
    updateToolPage: () => '/tools/:toolId/update',
    updateToolPageById: (toolId: string) => `/tools/${toolId}/update`,
  },
  api: {
    getAllLogs: () => '/logs',
    logsExport: () => '/logs/export',
    getLogsTypes: () => '/logs/types',
    settingsIp: () => '/settings/ip',
    ...userRoutes,
    ...consumerRoutes,
    ...tariffsRoutes,
    ...invoicesRoutes,
    ...announcementRoutes,
    ...messageRoutes,
    ...toolsRoutes,
    ...integrationsRoutes,
    ...referralRewardsRoutes,
    basePath: () => process.env.BACKEND_PATH,
  },
};
